import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

export const revertGRN = createAsyncThunk(
  "itemInward/revertGRN",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        `${API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.GRN?.REVERT(id)}`
      );
      return response?.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to revert GRN");
    }
  }
);

export const fetchGRNList = createAsyncThunk(
  "itemInward/fetchGRNList",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    warehouse_id,
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any[];
    warehouse_id?: string;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      const filterPayload = FilterBuilder(filters ?? []);

      const body = {
        filters: filterPayload,
      };

      const response: any = await Axios.post(
        `${
          API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.GRN?.LIST
        }?warehouse_id=${warehouse_id}&${params.toString()}`,
        body
      );
      return {
        data: response.data.data || [],
        rowCount: response.data.count || 0,
      };
    } catch (error: any) {
      throw new Error("Failed to fetch GRN List");
    }
  }
);

export const exportGRNCSV = async ({
  search,
  filters,
  warehouse_id,
}: {
  warehouse_id: string;
  search?: string;
  filters?: {
    filterField: string;
    filterValue: any;
  }[];
}) => {
  const params = new URLSearchParams();

  if (search) params.append("search", search);

  const filterPayload = FilterBuilder(filters ?? []);

  const body = {
    filters: filterPayload,
  };

  const response = await Axios.post(
    `${
      API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.GRN?.EXPORT
    }?warehouse_id=${warehouse_id}&${params.toString()}`,
    body,
    { responseType: "blob" }
  );

  return {
    blob: response.data,
    filename:
      response.headers["content-disposition"]
        ?.split("filename=")[1]
        ?.replace(/"/g, "") ||
      `grn_${new Date().toISOString().split("T")[0]}.csv`,
  };
};

export const fetchGRNId = createAsyncThunk(
  "itemInward/fetchGRNId",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.get(
        `${API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.GRN?.DETAIL(id)}`
      );
      return response?.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch GRN by ID");
    }
  }
);
export const fetchGRNProductsByProductId = createAsyncThunk(
  "itemInward/fetchGRNId",
  async (
    { inventory_id, product_id }: { inventory_id: String; product_id: String },
    { rejectWithValue }
  ) => {
    try {
      const response: any = await Axios.get(
        `${API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.GRN?.INVENTORY_ITEMS_DETAIL(
          inventory_id,
          product_id
        )}`
      );
      return response?.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to fetch GRN by ID");
    }
  }
);

export const fetchGRNDropdown = createAsyncThunk(
  "itemInward/fetchGRNDropDown",
  async (_, { rejectWithValue }) => {
    try {
      const response = await Axios.get(
        `${API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.GRN?.DROPDOWN}`
      );
      return response?.data?.data || [];
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch GRN Dropdown"
      );
    }
  }
);

export const updateGRN = createAsyncThunk(
  "itemInward/updateGRN",
  async ({ formData: data, inventory_id }: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.put(
        `${API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.GRN?.UPDATE(inventory_id)}`,
        data
      );
      return response;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to update GRN");
    }
  }
);

export const updateStatusGRN = createAsyncThunk(
  "itemInward/updateStatusGRN",
  async (id: string, { rejectWithValue }) => {
    try {
      const response: any = await Axios.patch(
        `${API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.GRN?.STATUS_UPDATE(id)}`
      );
      return response.data.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to update GRN status"
      );
    }
  }
);

export const createGRN = createAsyncThunk(
  "itemInward/createGRN",
  async (data: any, { rejectWithValue }) => {
    try {
      const response: any = await Axios.post(
        `${API_ENDPOINT?.WAREHOUSE?.ITEM_INWARD?.GRN?.CREATE}`,
        data
      );
      return response?.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || "Failed to Create GRN");
    }
  }
);
